<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey===item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findTrafficPoolName } from '@/api/traffic_pool'

export default {
  name: 'TrafficPoolShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'pool_info', tabName: '流量池信息概览' },
        { routeName: 'pool_cards', tabName: '流量池卡号列表' },
        { routeName: 'pool_expand_records', tabName: '流量池扩容记录' },
        { routeName: 'pool_usage_orders', tabName: '财务及流量信息' }
      ]
    }
  },
  computed: {
    trafficPoolId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    trafficPoolId() {
      this.setBreadcrumb()
    }
  },
  created() {
    this.activeKey = this.$route.name
    this.setBreadcrumb()
  },
  methods: {
    setBreadcrumb() {
      findTrafficPoolName(this.trafficPoolId).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':traffic_pool_name': res.data.name })
        }
      })
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
